"use client";
import { useEffect, useState } from "react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import AnimatedText from "@/components/common/AnimatedText";
import Link from "next/link";
import Image from "next/image";

export default function Facilities() {
  const [facilities, setFacilities] = useState([]);

  useEffect(() => {
    const fetchFacilities = async () => {
      try {
        const response = await fetch('/api/facilities');
        if (response.ok) {
          const data = await response.json();
          setFacilities(data);
        }
      } catch (error) {
        console.error('Failed to fetch facilities:', error);
      }
    };
    fetchFacilities();
  }, []);

  const swiperOptions = {
    spaceBetween: 30,
    speed: 2000,
    loop: true,
    modules: [Autoplay, Pagination, Navigation],
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".dot",
      clickable: true,
    },
    navigation: {
      nextEl: ".snbp1",
      prevEl: ".snbn1",
    },
    breakpoints: {
      1399: {
        slidesPerView: 3,
      },
      1199: {
        slidesPerView: 3,
      },
      991: {
        slidesPerView: 2,
      },
      767: {
        slidesPerView: 2,
      },
      575: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
  };
  return (
    <section
      id="services"
      className="service-section fix section-padding bg-cover  scrollSpySection"
    >
      <div className="container">
        <div className="section-title text-center">
          <h6 className="wow fadeInUp">
            Design to thrill
          </h6>
          <h2 className="splt-txt wow">
            <AnimatedText text="Attractions" />
          </h2>
        </div>
        <div className="array-button">
          <button className="array-prev snbp1">
            <i className="fa-regular fa-arrow-left-long"></i>
          </button>
          <button className="array-next snbn1">
            <i className="fa-regular fa-arrow-right-long"></i>
          </button>
        </div>
      </div>
      <div className="container">
        <Swiper {...swiperOptions} className="swiper service-slider">
          {facilities.length > 0 ? (
            facilities.map((item, index) => (
              <SwiperSlide className="swiper-slide" key={item._id || index}>
                <div className="service-box-items">
                  <div className="service-thumb">
                    <img
                      src={item.imgSrc}
                      width={346}
                      height={236}
                      alt={item.title || "img"}
                      style={{ objectFit: 'cover' }}
                    />
                  </div>
                  <div className="service-content">
                    <h2 className="number">{item.number}</h2>
                    <h3>
                      {/* <Link href={`/facilities/${item._id}`}> */}
                      <span style={{ color: "#168CC5" }}>{item.title}</span>
                      {/* </Link> */}
                    </h3>
                    <p>{item.description}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))
          ) : (
            <div className="text-center text-white">Loading facilities...</div>
          )}
        </Swiper>
      </div>
    </section>
  );
}
